import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Transformation() {
  const { t } = useTranslation();

  const cards = [
    { icon: 'ri-focus-3-line', text: t('phoenix.transformation1') },
    { icon: 'ri-robot-2-line', text: t('phoenix.transformation2') },
    { icon: 'ri-advertisement-line', text: t('phoenix.transformation3') },
    { icon: 'ri-settings-3-line', text: t('phoenix.transformation4') },
    { icon: 'ri-bar-chart-2-line', text: t('phoenix.transformation5') },
    { icon: 'ri-rocket-2-line', text: t('phoenix.transformation6') },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.transformationTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16 max-w-[800px]">
            {t('phoenix.transformationTitle')}
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <ScrollReveal key={i} direction="up" delay={i * 0.08}>
              <div className="group relative p-6 md:p-8 rounded-2xl bg-white border border-background-200/70 shadow-[0_2px_12px_rgba(0,0,0,0.03),0_1px_3px_rgba(0,0,0,0.02)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06),0_2px_8px_rgba(0,0,0,0.03)] hover:-translate-y-1 transition-all duration-400 cursor-default">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${card.icon} text-primary-600 text-xl`}></i>
                </div>
                <p className="text-foreground-800 font-medium text-base leading-snug">{card.text}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}